import React, { useRef } from 'react';
import Editor from '@monaco-editor/react';

interface PythonCodeViewerProps {
  code: string;
  readOnly?: boolean;
  height?: string;
}

export default function PythonCodeViewer({
  code,
  readOnly = false,
  height = '300px',
}: PythonCodeViewerProps) {
  const editorRef = useRef<any>(null);

  const handleEditorDidMount = (editor: any) => {
    editorRef.current = editor;
  };

  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
      <Editor
        height={height}
        language="python"
        theme="vs-dark"
        value={code}
        onMount={handleEditorDidMount}
        options={{
          fontSize: 14,
          minimap: { enabled: false },
          scrollBeyondLastLine: false,
          automaticLayout: true,
          tabSize: 4,
          insertSpaces: true,
          readOnly: readOnly,
        }}
      />
    </div>
  );
}
